function prefersReducedMotion() {
  return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function isDesignMode() {
  return Boolean(
    (window.Shopify && window.Shopify.designMode) ||
    document.documentElement.classList.contains('shopify-design-mode')
  );
}

/** Reduced motion applies on the live storefront; theme editor preview always allows motion. */
function shouldUseMotionFallback() {
  if (isDesignMode()) return false;
  return prefersReducedMotion();
}

function getAnimTargets(scopeEl) {
  const root = scopeEl instanceof Element ? scopeEl : document;
  return root.querySelectorAll('.animate-on-scroll');
}

function revealAll(targets) {
  targets.forEach((el) => {
    el.classList.add('is-visible');
  });
}

function replayElement(el) {
  if (!el) return;

  el.classList.remove('is-visible');
  if (el._scrollAnimObserver) {
    el._scrollAnimObserver.unobserve(el);
    delete el._scrollAnimObserver;
  }

  void el.offsetHeight;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      el.classList.add('is-visible');
    });
  });
}

function replayPreview(scopeEl) {
  const targets = getAnimTargets(scopeEl);
  if (!targets.length) return;

  targets.forEach((el) => {
    el.classList.remove('is-visible');
    if (el._scrollAnimObserver) {
      el._scrollAnimObserver.unobserve(el);
      delete el._scrollAnimObserver;
    }
  });

  void targets[0].offsetHeight;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      revealAll(targets);
    });
  });
}

function cleanupSection(sectionEl) {
  if (!sectionEl) return;

  const observers = new Set();
  sectionEl.querySelectorAll('.animate-on-scroll').forEach((el) => {
    if (el._scrollAnimObserver) {
      observers.add(el._scrollAnimObserver);
      delete el._scrollAnimObserver;
    }
  });
  observers.forEach((observer) => observer.disconnect());
}

function initScrollAnimations(scopeEl = document) {
  const targets = getAnimTargets(scopeEl);
  if (!targets.length) return;

  if (shouldUseMotionFallback() || !('IntersectionObserver' in window)) {
    revealAll(targets);
    return;
  }

  if (isDesignMode()) {
    replayPreview(scopeEl);
    return;
  }

  const pending = scopeEl.querySelectorAll('.animate-on-scroll:not(.is-visible)');
  if (!pending.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -12% 0px' }
  );

  pending.forEach((el) => {
    el._scrollAnimObserver = observer;
    observer.observe(el);
  });
}

window.initScrollAnimations = initScrollAnimations;

function initAll() {
  initScrollAnimations();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

document.addEventListener('shopify:section:load', (event) => {
  initScrollAnimations(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  cleanupSection(event.target);
});

document.addEventListener('shopify:section:select', (event) => {
  if (isDesignMode() && getAnimTargets(event.target).length && !shouldUseMotionFallback()) {
    replayPreview(event.target);
    return;
  }

  revealAll(getAnimTargets(event.target));
});

document.addEventListener('shopify:block:select', (event) => {
  const target = event.target;
  if (!(target instanceof HTMLElement)) return;

  target.scrollIntoView({ behavior: 'smooth', block: 'center' });

  if (!target.classList.contains('animate-on-scroll')) return;

  if (isDesignMode() && !shouldUseMotionFallback()) {
    replayElement(target);
  } else {
    target.classList.add('is-visible');
  }
});

document.addEventListener('shopify:section:deselect', () => {});
document.addEventListener('shopify:block:deselect', () => {});
